import { DateTime } from "luxon";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { useShowRankings } from "../../api/rankings";
import AboutThisReport from "../../shared/AboutThisReport";
import QueryDataTable from "../../shared/QueryDataTable";
import AboutRankings from "../AboutRankings";
import { NumberCell } from "../NumberCell";
import { RankCell } from "../RankCell";
import RankChart from "../RankChart";

export const numberFormat = new Intl.NumberFormat().format;
const deltaFormat = new Intl.NumberFormat(undefined, {
    signDisplay: "exceptZero",
}).format;

export function ShowRankingsPodtrac() {
    // TODO: store these in global state!
    const [country, setCountry] = useState("ZZZ");
    const [byCategory, setByCategory] = useState(false);
    const { accountID, showID } = useParams();
    const query = useShowRankings(accountID, showID),
        { data = [] } = query,
        rankings = data.filter((r) => r.countryCode === country);

    const config = {
        sheetName: "Podtrac Rankings",
        stickyRows: 1,
        stickyColumns: 1,
        key: (data) => data.rankMonth,
        sortColumn: "Month",
        sortDirection: "descending",
        schema: [
            {
                column: "Month",
                type: Date,
                value: (data) => new Date(data.rankMonth),
                width: 15,
                format: "mmm yyyy",
                html: {
                    component: ({ value, data }) => (
                        <td>
                            {DateTime.fromJSDate(value).toLocaleString({
                                month: "short",
                                year: "numeric",
                            })}
                        </td>
                    ),
                },
            },
            {
                column: "Country",
                type: String,
                value: (data) =>
                    data.countryCode === "ZZZ" ? "Global" : data.countryCode,
                width: 15,
            },
            {
                column: "Category",
                type: String,
                value: (data) => (byCategory ? data.category : "Overall"),
                width: 15,
            },
            {
                column: "UMA",
                type: Number,
                value: (data) => data.listeners,
                width: 15,
                html: {
                    component: NumberCell,
                },
            },
            {
                column: "UMA Rank",
                type: Number,
                value: (data) =>
                    byCategory ? data.categoryListenerRank : data.listenerRank,
                width: 15,
                html: {
                    component: ({ data, value }) => (
                        <RankCell
                            rank={value}
                            prevRank={
                                byCategory
                                    ? data.previousCategoryListenerRank
                                    : data.previousListenerRank
                            }
                        />
                    ),
                },
            },
            {
                column: "UMA Percentile",
                type: Number,
                value: (data) =>
                    byCategory
                        ? data.categoryListenerPercentile
                        : data.listenerPercentile,
                width: 15,
                html: {
                    component: NumberCell,
                },
            },
            {
                column: "Downloads",
                type: Number,
                value: (data) => data.downloads,
                width: 15,
                html: {
                    component: NumberCell,
                },
            },
            {
                column: "Download Rank",
                type: Number,
                value: (data) =>
                    byCategory ? data.categoryDownloadRank : data.downloadRank,
                width: 15,
                html: {
                    component: ({ data, value }) => (
                        <RankCell
                            rank={value}
                            prevRank={
                                byCategory
                                    ? data.previousCategoryDownloadRank
                                    : data.previousDownloadRank
                            }
                        />
                    ),
                },
            },
            {
                column: "Download Percentile",
                type: Number,
                value: (data) =>
                    byCategory
                        ? data.categoryDownloadPercentile
                        : data.downloadPercentile,
                width: 15,
                html: {
                    component: NumberCell,
                },
            },
        ],
    };

    return (
        <>
            {" "}
            <Helmet>
                <title>Rankings - Podtrac</title>
            </Helmet>
            <div style={{ display: "flex", alignItems: "center" }}>
                <h1 style={{ flex: 1 }}>Podtrac Rankings</h1>
                <AboutThisReport title="Rankings" component={AboutRankings} />
            </div>
            <p style={{ fontSize: "0.75em", margin: "0.25em" }}>
                Compare your show to all Podtrac-measured podcasts
            </p>
            <QueryDataTable
                query={query}
                config={config}
                filter={(r) => r.countryCode === country}
                chart={
                    <RankChart
                        data={rankings.slice(0, -1).reverse() /* HACK */}
                        downloadIndex={
                            byCategory ? "categoryDownloadRank" : "downloadRank"
                        }
                        listenerIndex={
                            byCategory ? "categoryListenerRank" : "listenerRank"
                        }
                    />
                }
            >
                <select onChange={(event) => setCountry(event.target.value)}>
                    <option value="ZZZ">Global</option>
                    <option value="USA">USA</option>
                </select>
                <select
                    onChange={(event) => setByCategory(!!event.target.value)}
                >
                    <option value="">Overall</option>
                    <option value="true">By Category</option>
                </select>
            </QueryDataTable>
        </>
    );
}
